import { useMutation, useQueryClient } from 'react-query';
import { useSelector, useDispatch } from 'react-redux';
import { authFetch } from '../../CommonUtils/authFetch';
import { selectCurrentClient } from '../../CommonSelectors/CommonAreaSelector';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { fetchCurrentClient } from '../../AdviserArea/AdviserAreaActions';
import { queryKeys } from '../../DocumentVault/api/queryKeys';

export const UNLINK_ORION_CONSUMER_MK = 'unlinkOrionConsumer';

const unlinkOrionConsumer = (clientId: number) => (deleteAccountsFromHousehold: boolean) => {
  return authFetch(
    urlWithParams('/Consumer/ClientSettingsUpdate/UnlinkOrionConsumer', {
      clientId,
      deleteAccountsFromHousehold,
    }),
    {
      method: 'POST',
    },
  );
};

export const useUnlinkOrionConsumerMutation = () => {
  const { Id: clientId } = useSelector(selectCurrentClient);

  const dispatch = useDispatch();

  const queryClient = useQueryClient();

  return useMutation(unlinkOrionConsumer(clientId), {
    mutationKey: UNLINK_ORION_CONSUMER_MK,

    onSuccess: (_, deleteAccountsFromHousehold) => {
      // update other parts of the app for client (vertical menu, client overview, etc)
      dispatch(fetchCurrentClient(clientId));

      // clear cache for document vault query
      if (deleteAccountsFromHousehold) {
        queryClient.invalidateQueries(queryKeys.listDocumentVaultEntities(clientId));
      }
    },
  });
};
